module.exports = __webpack_public_path__ + "static/media/051-home.c6d282ee.svg";